export interface NoteReclamationState {
    jwt: string
}

export const initialState: NoteReclamationState = {
    jwt: ''
};

export const state: NoteReclamationState = {
    ...initialState
};
